/* @jsx h */
import { defineComponent, h, PropType } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export const PartySizeSelector = defineComponent({
  name: "PartySizeSelector",
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 20,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const { t } = useLocalization();
    const decrease = () => {
      if (props.modelValue > props.min) {
        emit("update:modelValue", props.modelValue - 1);
      }
    };

    const increase = () => {
      emit("update:modelValue", props.modelValue + 1);
    };

    return () => (
      <div
        class={
          props.compact
            ? "pb-4 border-b border-gray-200"
            : "bg-white rounded-lg border border-gray-200 p-4"
        }
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span
              class="material-symbols-outlined text-2xl text-gray-700"
              aria-hidden="true"
            >
              group
            </span>
            <label class="text-lg font-semibold text-gray-900">
              {t("customer.reserve.guests")}
            </label>
            <span class="text-xs text-gray-500">{props.min}+</span>
          </div>
          <div class="flex items-center">
            <button
              type="button"
              class="w-11 h-11 flex items-center justify-center rounded-full border border-gray-400 hover:bg-gray-100 transition-colors disabled:opacity-30 disabled:hover:bg-transparent"
              disabled={props.modelValue <= props.min}
              onClick={decrease}
            >
              <span class="material-symbols-outlined text-gray-800 text-xl">
                remove
              </span>
            </button>
            <span class="text-2xl font-semibold w-12 text-center tabular-nums">
              {props.modelValue}
            </span>
            <button
              type="button"
              class="w-11 h-11 flex items-center justify-center rounded-full border border-gray-400 hover:bg-gray-100 transition-colors disabled:opacity-30 disabled:hover:bg-transparent"
              onClick={increase}
            >
              <span class="material-symbols-outlined text-gray-800 text-xl">
                add
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  },
});
